<template>
  <div class="hero">
    <div
        v-swiper:heroSwiper="heroOption"
        @slideChange="myChanger"
        class="hero-slider"
    >
      <div class="hero-navigation">
        <div class=" hero-slider__prev" @click="heroSwiper.slidePrev()" :style="$browserDetect.isIE ? 'top:64%' : ''">
          <svg width="22" height="40" viewBox="0 0 22 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M20.587 0.707078C20.191 0.316553 19.549 0.316554 19.153 0.707078L0.297012 19.3016C-0.0990037 19.6921 -0.0990039 20.3253 0.297011 20.7158C0.460564 20.8771 0.666085 20.9717 0.878909 20.9998L19.4288 39.2928C19.8248 39.6833 20.4669 39.6833 20.8629 39.2928C21.2589 38.9023 21.2589 38.2691 20.8629 37.8786L2.59495 19.8639L20.587 2.12129C20.9831 1.73077 20.9831 1.0976 20.587 0.707078Z"
                  fill="black"/>
          </svg>
        </div>
        <div class="hero-slider__next" @click="heroSwiper.slideNext()" :style="$browserDetect.isIE ? 'top:64%' : ''">
          <svg width="21" height="40" viewBox="0 0 21 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="1.92337" height="27.2125" rx="0.961687"
                  transform="matrix(-0.677766 0.735278 0.677766 0.735278 2.13629 0)" fill="black"/>
            <path
                d="M18.3679 19.2896C18.7294 18.8974 19.3161 18.8993 19.6754 19.294C20.0315 19.6852 20.0297 20.3149 19.6713 20.7036L2.53538 39.2939C2.1754 39.6845 1.59176 39.6845 1.23178 39.2939C0.871805 38.9034 0.871805 38.2702 1.23178 37.8797L18.3679 19.2896Z"
                fill="black"/>
          </svg>
        </div>
      </div>
      <div class="swiper-wrapper">
        <div
            class="swiper-slide hero-slider__slide"
            :key="item.alt"
            v-for="item in content.slides"
            :style="windowWidth > 500 ? `background-image: url(${item.image})` : `background-image: url(${item.image_mobile})`"
        >
          <div class="content" :style="$browserDetect.isIE ? 'height:400px;margin-top: 150px' : ''">
            <h1>{{ item.content.title }}</h1>
            <Button class="btn__hero" :content="item"/>
          </div>
        </div>
      </div>
      <div class="small-hero" v-if="!this.$browserDetect.isIE">
        <div v-swiper:heroPaginationSwiper="heroPaginationOption" class="small-hero__slider">
          <div class="swiper-wrapper">
            <div
                :class="['swiper-slide', 'small-hero__item',index === activeIndex ? 'active' : '']"
                :key="item.alt"
                v-for="(item,index) in content.slides"
            >
              <a>
                <img :src="item.smallImage">
              </a>
              <div @click="slideTo(index)" class="small-hero__circle"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../elements/button/Button";

export default {
  components: {Button},
  props: ['content'],
  data() {
    return {
      activeIndex: 0,
      heroPaginationOption: {
        slidesPerView: 'auto',
        speed: 0,
        allowTouchMove: false
      },
      heroOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination'
        },
      },
      init: false,
      smallHeroOption: {
        allowTouchMove: false
      }
    }
  },

  mounted() {
    this.heroSwiper.on('slideChange', () => {
      this.heroPaginationSwiper.slideTo(this.heroSwiper.activeIndex);
    })

    this.heroSwiper.init(this.heroOption);
  },

  methods: {
    myChanger() {
      this.activeIndex = this.heroSwiper.activeIndex
    },
    slideTo(i) {
      this.heroSwiper.slideTo(i, 1500);
      this.heroPaginationSwiper.slideTo(i);
    }
  },
  computed: {
    windowWidth() {
      return window.innerWidth
    }
  }
}
</script>
<style lang="scss">
@import "hero.scss";
</style>